import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';
import CountriesList from './CountriesList';
import Profile from './Profile';
import RecommendedPriceToggle from './RecommendedPriceToggle';
import VATHeading from './VATHeading';
import TopLinks from './TopLink';
import LogOut from './LogOut';

const NavigationItem = ({ links = [], contentLink = null, level = 1 }) => {
  const menuRef = useRef(null);
  const megaMenuRef = useRef(null);

  const toggleMenu = (toggleAll) => {
    const selectedLinks = document.querySelectorAll(
      '#navbar .navbar__link--selected'
    );

    if (selectedLinks.length && toggleAll) {
      for (const link of selectedLinks) {
        let closestMenu = link.closest('ul');
        closestMenu.classList.toggle('navbar__menu--show');
      }
    } else {
      menuRef.current.classList.toggle('navbar__menu--show');
    }

    const isMenuOpen = menuRef.current.classList.contains('navbar__menu--show');
    if (isMenuOpen) {
      document.body.classList.add('no-scroll');
    }
  };

  const closeMenu = () => {
    for (const menu of document.querySelectorAll('.navbar__menu--show')) {
      menu.classList.remove('navbar__menu--show');
      document.body.classList.remove('no-scroll');
    }
  };

  const toggleMenuClick = () => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      megaMenuRef.current.focus();
    } else {
      toggleMenu();
    }
  };

  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const showMegaMenuDesktop = contentLink && contentLink.showMegaMenuDesktop;

  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
  const hasChildrenClass =
    links.length > 0
      ? showMegaMenuDesktop
        ? 'has-children'
        : ''
      : 'last--selected';
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;
  const hasMegaMenu = level === 1 && links.length;
  const showImageOnMegaMenu =
    contentLink && contentLink.showImageMegaMenu ? ' showImageonMegaMenu' : '';

  return (
    <Fragment>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon"
          onClick={() => toggleMenu(true)}
          rel="nofollow"
          href="#"
          title={translate('general.menu') || 'menu'}
        >
          <svg className="menu-icon">
            <use href="/ui/images/sprites/brenderup.svg#menu"></use>
          </svg>
        </a>
      ) : (
        <Fragment>
          <a
            className={`navbar__link ${selectedClass} ${
              hasChildrenClass || ''
            } ${additionClass || ''}  ${showImageOnMegaMenu || ''}`}
            {...(hasMegaMenu && showMegaMenuDesktop
              ? { onClick: toggleMenuClick }
              : { href: contentLink.url || '#' })}
            dangerouslySetInnerHTML={{ __html: contentLink.name }}
          ></a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={() => toggleMenu(false)}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <ul
          tabIndex="0"
          className={
            contentLink == null
              ? 'navbar__menu'
              : showMegaMenuDesktop
              ? 'navbar__menu showindesktop'
              : 'navbar__menu showinmobile'
          }
          ref={menuRef}
        >
          {level === 1 && (
            <Fragment>
              {' '}
              <a className="hidden" tabIndex="-1" ref={megaMenuRef}></a>
              <a
                className="navbar__menu--parent-desktop"
                href={contentLink.url}
              >
                {contentLink.name}{' '}
              </a>
            </Fragment>
          )}

          <div className="navbar__menu-header">
            {!contentLink ? (
              <span
                className="navbar__icon navbar__icon--close"
                onClick={() => closeMenu()}
              ></span>
            ) : (
              <Fragment>
                <i
                  className="navbar__icon--caret-left navbar__icon"
                  onClick={() => toggleMenu(false)}
                ></i>
                {contentLink.parentName && (
                  <a
                    href={contentLink.parentURL}
                    className="navbar__title"
                    onClick={() => toggleMenu(false)}
                    dangerouslySetInnerHTML={{
                      __html: contentLink.parentName,
                    }}
                  ></a>
                )}

                <span
                  className="navbar__icon navbar__icon--close"
                  onClick={() => closeMenu()}
                ></span>
              </Fragment>
            )}
          </div>

          {contentLink != null && (
            <li className="navbar__menu--parent-mobile">
              <a href={contentLink.url}>{contentLink.name}</a>
            </li>
          )}
          {links.length > 0 &&
            links.map(
              (link, i) =>
                hasNameOrChildren(link) && (
                  <li
                    className={
                      'navbar__item' +
                      (link.isColumnMenu ? ' column-menu' : ' ') +
                      (link.showImageMegaMenu ? ' showImageonMegaMenu' : ' ')
                    }
                    key={i + '_' + link.url}
                  >
                    {link.showImageMegaMenu && link.imageUrl && (
                      <a
                        href={link.url}
                        tabIndex={-1}
                        dangerouslySetInnerHTML={{ __html: link.imageUrl }}
                      ></a>
                    )}
                    <NavigationItem
                      links={link.links}
                      contentLink={link}
                      level={level + 1}
                    />
                  </li>
                )
            )}
          <li className="navbar__item mobile-extra-links top-links-mobile hide-for-large">
            <TopLinks />
          </li>
          <li className="navbar__item mobile-extra-links top-links-mobile hide-for-large">
            <Profile />
          </li>
          <li className="navbar__item mobile-extra-links change-country-mobile hide-for-large">
            <CountriesList />
          </li>
          <li className="navbar__item mobile-extra-links vat-mobile hide-for-large">
            <VATHeading />
          </li>
          <li className="navbar__item mobile-extra-links vat-mobile rec-toggle hide-for-large">
            <RecommendedPriceToggle />
          </li>
          <li className="navbar__item mobile-extra-links vat-mobile hide-for-large">
            <LogOut />
          </li>
        </ul>
      )}
    </Fragment>
  );
};

export default NavigationItem;
